import MyTooltip from "@common-utils/MyTooltip"
import React from "react"
import { usePersonnelDetailsContext } from "./PersonnelDetails"
import useUser from "../../../hooks/useUser"

const Navigation = () => {
     const context = usePersonnelDetailsContext()
     const { hasFullStaffManagement, canManageStaffNfc } = useUser()

     return (
          <>
               <div className="d-flex justify-content-center rounded mb-5 border-bottom">
                    <MyTooltip title={"Informations de base"}>
                         <span
                              className={`${
                                   context.selectedNavigationItem === "INFO_BASE" ? "text-primary border-bottom border-primary" : "text-hover-primary cursor-pointer"
                              } me-10 pb-2`}
                              onClick={() => context.setSelectedNavigationItem("INFO_BASE")}
                         >
                              <span className={"fas fa-user"} style={{ fontSize: "2rem" }} />
                         </span>
                    </MyTooltip>
                    <MyTooltip title={"Documents"}>
                         <span
                              className={`${
                                   context.selectedNavigationItem === "DOCUMENTS" ? "text-primary border-bottom border-primary" : "text-hover-primary cursor-pointer"
                              } me-10`}
                              onClick={() => context.setSelectedNavigationItem("DOCUMENTS")}
                         >
                              <span className={"fas fa-folder-open"} style={{ fontSize: "2rem" }} />
                         </span>
                    </MyTooltip>
                    <MyTooltip title={"Activité (déclarations, arrêts maladie, congés)"}>
                         <span
                              className={`${
                                   context.selectedNavigationItem === "ACTIVITE" ? "text-primary border-bottom border-primary" : "text-hover-primary cursor-pointer"
                              } me-10`}
                              onClick={() => context.setSelectedNavigationItem("ACTIVITE")}
                         >
                              <span className={"fas fa-calendar-check"} style={{ fontSize: "2rem" }} />
                         </span>
                    </MyTooltip>
                    <MyTooltip title={"Suivi (journal des actions)"}>
                         <span
                              className={`${
                                   context.selectedNavigationItem === "SUIVI" ? "text-primary border-bottom border-primary" : "text-hover-primary cursor-pointer"
                              } me-10`}
                              onClick={() => context.setSelectedNavigationItem("SUIVI")}
                         >
                              <span className={"fas fa-clock-rotate-left"} style={{ fontSize: "2rem" }} />
                         </span>
                    </MyTooltip>
                    {/* Carte NFC — accès complet uniquement */}
                    {canManageStaffNfc() && (
                         <MyTooltip title={"Carte NFC"}>
                              <span
                                   className={`${context.selectedNavigationItem === "NFC" ? "text-primary border-bottom border-primary" : "text-hover-primary cursor-pointer"} me-10`}
                                   onClick={() => context.setSelectedNavigationItem("NFC")}
                              >
                                   <span className={"fas fa-id-card-clip"} style={{ fontSize: "2rem" }} />
                              </span>
                         </MyTooltip>
                    )}
                    {/* Google Workspace — réservé à l'accès complet */}
                    {hasFullStaffManagement() && (
                         <MyTooltip title={"Google Workspace"}>
                              <span
                                   className={`${context.selectedNavigationItem === "GOOGLE" ? "text-primary border-bottom border-primary" : "text-hover-primary cursor-pointer"} me-10`}
                                   onClick={() => context.setSelectedNavigationItem("GOOGLE")}
                              >
                                   <span className={"fab fa-google"} style={{ fontSize: "2rem" }} />
                              </span>
                         </MyTooltip>
                    )}
                    {/* Paramètres du compte — réservé à l'accès complet */}
                    {hasFullStaffManagement() && (
                         <MyTooltip title={"Paramètres du compte"}>
                              <span
                                   className={`${context.selectedNavigationItem === "COMPTE" ? "text-primary border-bottom border-primary" : "text-hover-primary cursor-pointer"}`}
                                   onClick={() => context.setSelectedNavigationItem("COMPTE")}
                              >
                                   <span className={"fas fa-power-off"} style={{ fontSize: "2rem" }} />
                              </span>
                         </MyTooltip>
                    )}
               </div>
          </>
     )
}

export default Navigation
